import { Box, BoxProps } from '../Elements';

export type SectionProps = BoxProps;

export const Section = ({ children, ...rest }: BoxProps) => {
  return (
    <Box marginTop="8x" {...rest}>
      {children}
    </Box>
  );
};
